import axiosInstance from "@/api/axiosInstance";
import {
  BatchConvertFilesRequest,
  BatchConvertFilesResponse,
  BatchConvertFilesResponseData,
} from "./types";

export const batchConvertFilesToPublic = async (
  fileUuids: string[],
): Promise<BatchConvertFilesResponseData> => {
  const response = await axiosInstance.post<BatchConvertFilesResponse>(
    "/api/private/file-management/files/batch-convert",
    {
      fileUuids,
      makePublic: true,
    } as BatchConvertFilesRequest,
  );

  return response.data.data; // Unwrap the data property
};
